import { IResult } from '../../models/result-models';
import * as talend from '../../models/talend';
import { LOAD_PROMODETAILS_SUCCESS } from './promo-detail-actions';

interface LoadPromoDetailsAction {
    type: 'LOAD_PROMODETAILS_SUCCESS';
    result: IResult<talend.IPromoDetail[]>;
}

type KnownAction = LoadPromoDetailsAction;

export const promoDetailsReducer = (
    state: IResult<talend.IPromoDetail[]> | null | undefined = null,
    action: KnownAction
) => {
    switch (action.type) {
        case LOAD_PROMODETAILS_SUCCESS:
            return action.result;
        default:
            return state;
    }
};
